import * as React from 'react';
import './AccountInfo.scss';
import UserModel from 'src/model/user.model';

interface IAccountInfoProps {
  userData: UserModel;
}

export function AccountInfo(props: IAccountInfoProps) {
  const userName = props.userData
    ? props.userData.name && props.userData.name.length
      ? props.userData.name
      : `#${props.userData.accountId}`
    : '';

  const email =
    props.userData && props.userData.email && props.userData.name.length
      ? props.userData.email
      : '';

  return (
    <div className="rp-accountinfoheader">
      <div className="rp-accountinfo">
        <div className="container-fluid rp-accountinfo-content">
          <div className="row">
            <div className="col-12 col-md-6">
              <h1>Hello, {userName}</h1>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="rp-accountinfo--item-title">Email Address:</div>
              <div className="rp-accountinfo--item-detail">{email}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
